module.exports = __webpack_public_path__ + "static/media/britta aakar ma.868bd06e.wav";